import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import CustomerForm from "./CustomerForm";
import { createCustomerValidationForm } from "../../utils/validationSchemas";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateCustomer = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createCustomerValidationForm),
  });
  const {
    handleCreate,
    isLoading,
    setOpenAddReceiverPopup,
    openAddReceiverPopup,
  } = props;

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleCreate(data, setError))}
      autoComplete="off"
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
      />
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] mr-4`}>
          <Button
            label={"Create"}
            isLoading={isLoading}
            onClick={() => setOpenAddReceiverPopup(!openAddReceiverPopup)}
          />
        </div>
      </div>
    </form>
  );
};

export default CreateCustomer;
